import type { AnalysisResult } from '@/hooks/use-homepage-analysis'
import type { RefinementTrigger } from '@/lib/analysis/refinement-policy'

export const SCAN_RECOVERY_KEY = 'pendingAnalysis_recovery'
export const SCAN_RECOVERY_TTL = 60 * 60 * 1000

export interface ScanRecoveryState {
  id: string
  savedAt: number
  mode: 'identify' | 'diagnose'
  reason: 'photo' | 'network' | 'save' | 'server'
  imageUrl: string
  supportingImageUrls: string[]
  zipCode: string
  skipZip: boolean
  result: AnalysisResult | null
  analysisId: string | null
  resultAccessToken: string | null
  funnelId: string | null
  attemptId: string | null
  refinement?: {
    rootId: string | null
    trigger: RefinementTrigger | null
    guidance: string | null
  }
}

export function saveScanRecovery(state: ScanRecoveryState): void {
  try {
    localStorage.setItem(SCAN_RECOVERY_KEY, JSON.stringify(state))
  } catch {
    throw new Error('This browser could not keep your photo for sign-in. You can still retry here.')
  }
}

export function readScanRecovery(id: string, trustsImage: (url: string) => boolean): ScanRecoveryState | null {
  try {
    const state = JSON.parse(localStorage.getItem(SCAN_RECOVERY_KEY) || 'null') as ScanRecoveryState | null
    if (!state || state.id !== id || !state.savedAt || Date.now() - state.savedAt > SCAN_RECOVERY_TTL) return null
    if (!['identify', 'diagnose'].includes(state.mode) || !['photo', 'network', 'save', 'server'].includes(state.reason)) return null
    if (!trustsImage(state.imageUrl) || !Array.isArray(state.supportingImageUrls) || !state.supportingImageUrls.every(trustsImage)) return null
    if (typeof state.zipCode !== 'string' || typeof state.skipZip !== 'boolean') return null
    if (state.reason === 'photo' && (!state.result || typeof state.result.grassType !== 'string' || !Array.isArray(state.result.tips))) return null
    return state
  } catch {
    return null
  }
}
